import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: ${({ $align }) =>
    $align === "left"
      ? "flex-start"
      : $align === "right"
      ? "flex-end"
      : "center"};
  align-items: center;
  width: fit-content;
`;

const RegularPrice = styled.div`
  margin: 0;
  color: ${({ $color }) => `var(--color-${$color}, var(--color-black))`};
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
`;

const SaleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const OldPrice = styled.p`
  margin: 0;
  color: ${({ $color }) => `var(--color-${$color}, var(--color-black))`};
  font-size: ${({ $fontSize }) => ($fontSize ? `${$fontSize}px` : "0.9rem")};
  text-decoration: line-through;
`;

const SalePrice = styled.p`
  margin: 0;
  color: ${({ $saleColor }) =>
    `var(--color-${$saleColor}, var(--color-black))`};
  font-size: ${({ $saleFontSize }) =>
    $saleFontSize ? `${$saleFontSize}px` : "0.9rem"};
`;

const ProductPrice = ({
  product,
  className,
  align,
  showPriceRange = false,
  customFontSize,
  color,
  saleColor,
  customSaleFontSize,
}) => {
  const formatPrice = (price) => {
    const numericPriceString = price.replace(/[^\d.-]/g, "");

    if (!showPriceRange && numericPriceString.split("-").length > 1) {
      return (
        "Fra " +
        `<span class="price">${parseFloat(
          numericPriceString.split("-")[0]
        )}</span> ,-`
      );
    }
    return `<span class="price">${parseFloat(numericPriceString)}</span>,-`;
  };

  return (
    <Wrapper $align={align} className={className}>
      {product?.onSale === true ? (
        <SaleWrapper>
          <SalePrice
            $saleColor={saleColor}
            $saleFontSize={customSaleFontSize}
            dangerouslySetInnerHTML={{
              __html: product.salePrice && formatPrice(product.salePrice),
            }}
          />
          <OldPrice
            $color={color}
            $fontSize={customFontSize}
            dangerouslySetInnerHTML={{
              __html:
                product?.regularPrice && formatPrice(product?.regularPrice),
            }}
          />
        </SaleWrapper>
      ) : (
        <RegularPrice
          $color={color}
          $fontSize={customSaleFontSize}
          dangerouslySetInnerHTML={{
            __html: product?.price && formatPrice(product?.price),
          }}
        />
      )}
    </Wrapper>
  );
};

ProductPrice.propTypes = {
  product: PropTypes.shape({
    onSale: PropTypes.bool,
    salePrice: PropTypes.string,
    regularPrice: PropTypes.string,
    price: PropTypes.string,
  }),
  customFontSize: PropTypes.number,
  showPriceRange: PropTypes.bool,
  customSaleFontSize: PropTypes.number,
  color: PropTypes.string,
  saleColor: PropTypes.string,
  align: PropTypes.string,
  currency: PropTypes.string,
  className: PropTypes.string,
};

export default ProductPrice;
